import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { Button, Modal } from '@getro/rombo';
import { Box, Flex, Text } from 'rebass/styled-components';

export const DeleteFolderModal = ({ isLoading, onCloseModal, onDeleteFolder }) => (
  <Box data-testid="delete-folder-modal" onClick={(e) => e.stopPropagation()}>
    {createPortal(
      <Modal
        title="Delete folder?"
        isOpen
        onCancel={onCloseModal}
        actions={
          <Flex sx={{ gap: '8px', justifyContent: 'flex-end' }}>
            <Button variant="secondary" onClick={onCloseModal}>
              Cancel
            </Button>
            <Button data-testid="delete-folder-btn" variant="danger" onClick={onDeleteFolder} loading={isLoading}>
              Delete folder and contents
            </Button>
          </Flex>
        }
      >
        <Box as="ul" pl="24px" pt="8px">
          <Box as="li">Permanently delete the folder itself</Box>
          <Box as="li">Permanently delete all folders and lists inside it</Box>
        </Box>
        <Text mt="3" fontWeight={500}>
          <Text as="span" mr="2">
            ⚠️
          </Text>
          This action cannot be undone.
        </Text>
      </Modal>,
      document.getElementById('portals'),
    )}
  </Box>
);

DeleteFolderModal.propTypes = {
  isLoading: PropTypes.bool,
  onCloseModal: PropTypes.func.isRequired,
  onDeleteFolder: PropTypes.func.isRequired,
};

DeleteFolderModal.defaultProps = {
  isLoading: false,
};

export default DeleteFolderModal;
